<!--
    @author qixf@thinkerx.com
    @remark 付款记录
    @created 2020/5/7
-->
<template>
  <div>
    <!-- 时间筛选 -->
    <el-row style="margin: 15px 0;">
      <el-col :span="12">
        <el-button type="primary" @click="exportData">导出</el-button>
      </el-col>
      <el-col :span="12">
        <el-date-picker style="float: right"
                        v-model="date_range" type="daterange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        value-format="yyyy-MM-dd" @change="getList">
        </el-date-picker>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-table border stripe
              show-summary :summary-method="getSummaries"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="updated_at"
        label="付款时间"
        width="180">
      </el-table-column>
      <el-table-column
        prop="phone_number"
        label="付款账号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="money"
        label="金额"
        width="180">
      </el-table-column>
      <el-table-column
        prop="yqr"
        label="邀请人"
        width="150">
      </el-table-column>
      <el-table-column
        prop="yqr_phone"
        label="邀请人账号"
        width="180">
      </el-table-column>
	  <el-table-column
	    prop="order_no"
	    label="交易号">
	  </el-table-column>
      <el-table-column
        prop="subject"
        label="购买说明">
      </el-table-column>
      <el-table-column
        prop="note"
        label="备注">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="padding: 15px 0; text-align: right;">
      <el-pagination
                     :hide-on-single-page="true" background
                     @current-change="handleCurrentChange"
                     :current-page="pagination.page"
                     :page-size="pagination.page_size"
                     layout="total, prev, pager, next, jumper"
                     :total="pagination.total">
      </el-pagination>
    </div>
    <div style="height: 100px;"></div>
  </div>
</template>
<script>
export default {
  name: "payment-log",
  data() {
    return {
      date_range: ["",""],
      list: [],
      pagination: {
        page: 1, total: 400, page_size: 15
      }
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    getList() {
      let params = {
        page: this.pagination.page,
        start_date: this.date_range[0],
        end_date: this.date_range[1]
      };
      this.list = [];
      this.$axios.get("pay-orders", params).then(res => {
        this.list = res.data;
        this.list.forEach(item=> {
          if (item.type == 1)
            this.$set(item,'note',`续费`);
          else if (item.type == 2)
            this.$set(item,'note',`新购买 ${item.users} 个账号}`);
          else if (item.type == 3)
            this.$set(item,'note',
              `${item.users>1?'团队版('+item.users+'个)':'个人版'}`);
        });
        this.pagination.total = res.total;
      });
    },
    /** 自定义总计 **/
    getSummaries(param) {
      const { columns, data } = param;
      let sums = [];
      columns.forEach((column, index) => {
        if (index === 0) sums[index] = '总价';
        else if (index === 2) {
          const values = data.map(item => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else sums[index] = '';
      });
      return sums;
    },
    /** 导出 **/
    exportData() {
      this.$axios.get("excel-pay-orders", {}).then(res => {
        window.location.href = `${process.env.VUE_APP_BASEURL1}${res.data}`;
      })
    }
  },
  mounted() {
    this.getList();
  }
}
</script>
<style lang="scss" scoped>
</style>